import React from "react"
import classnames from "classnames"
import { Section } from "AtomicComponents"
import styles from "./ColumnGroup.less"
import componentParser from "AtomicUtils/componentParser"


// This Comopnents tries to put everything in one row
class ColumnGroup extends React.PureComponent {

  _map = (items) => {
    if (!items || items.length === 0) return

    if (!Array.isArray(items)) items = [items]

    // remove undefined ones
    items = items.filter(item => {
      if (typeof item === "undefined") return false
      if (item === null) return false
      return true
    })

    const { sizes = [] } = this.props
    return items.map((item, index) => {
      let ratio = 100
      if (!sizes || sizes.length === 0) ratio = 100/items.length
      else ratio = sizes[index]

      return (
        <div
          key={`ColumnGroupItem-${index}`}
          style={{
            flex: `1 1 ${ratio}%`,
            display: "flex",
            alignItems: item.props && item.props.alignMiddle ? "center" : "flex-start",
            justifyContent: item.justifyContent || "center",
            overflow: "hidden",
            maxWidth: "100%"
          }}
          className={classnames({
            [styles.ColumnGroupItem]: true
          })}>
          {item}
        </div>
      )
    })
  }

  render() {

    const {
      components = [],
      children,
      backgroundColor,
      fullWidth=true,
      reverseOnDesktop=false,
      reverseOnMobile=false,
      size="disable",
      center = true
    } = this.props

    let minHeight = "initial"
    // size definition for columnsgroup
    if (size === "large") minHeight = "40vw"
    if (size === "medium") minHeight = "30vw"
    if (size === "small") minHeight = "20vw"
    if (size === "disable") minHeight = "initial"

    return (
      <Section
         backgroundColor={backgroundColor}
         fullWidth={fullWidth}
         center={center}
      >
        <div
          data-test="column-group"
          className={classnames({
            [styles.ColumnGroup]: true,
            [styles.ColumnGroup__ReverseDesktop]: reverseOnDesktop,
            [styles.ColumnGroup__ReverseMobile]: reverseOnMobile
          })}
          style={{
            minHeight: minHeight,
            overflow: "hidden"
          }}
        >
          {components && components.length > 0 && this._map(componentParser(components, this.props))}
          {(!components || components.length === 0) && this._map(children)}
        </div>
      </Section>
    )
  }
}


export default ColumnGroup



// WEBPACK FOOTER //
// ./src/AtomicComponents/ColumnGroup/ColumnGroup.jsx